import { Injectable } from '@angular/core';
import { SxHttpService } from './sxHttp.service';
import { Observable } from 'rxjs/Observable';
import { ItemGeneralListado } from 'app/helpers/components/itemClasses/itemListadoGeneral.class';
import { SxTranslationService } from 'app/infrastructure/services/translation-service.service';

@Injectable()
export class SOCUsersConfigService {
  private url = 'api/configSocUsers';

  constructor(private sxHttp: SxHttpService,
    private sxTranslationService: SxTranslationService) { }

  /**
   * Dado un tipo de select, retorna el listado de opciones que hidratan el
   * select correspondiente a ese tipo de select
   */
  getConfiguration(mode:string): Observable<ItemGeneralListado[]> {
    const url = this.url + '/GetConfiguration/' + mode;

    return this.sxHttp.get(url)
      .map(response => {
        let elements:ItemGeneralListado[] = [ ];
        (response.json().data as any[]).forEach(element => {
          const append:ItemGeneralListado={
            id: element.id, 
            Titulo: this.getTituloComando(element.titulo).titulo,
            Descripcion: this.getTituloComando(element.titulo).descripcion,
            Imagen: this.getIconoComando(element.titulo),
            UrlDestination: null
          }
          elements.push(append);
        });

        return elements;
            });
  }
 
  /**
   * Retorna el icono que representa al comando
   *
   * @param codComando El id del comando
   */
  getIconoComando(codComando: string): string {
    const mapping = {
      Alta: 'fa fa-3x fa-user-plus',
      AltaExpress: 'fa fa-3x fa-angle-double-right',
      Blanqueo: 'fa fa-3x fa-user-o',
      Bloqueo: 'fa fa-3x fa-user-times',
      CambioPassword: 'fa fa-3x fa-lock',
      Consulta: 'fa fa-3x fa-question',
      Edicion: 'fa fa-3x fa-pencil-alt-square-o',
      Listado: 'fa fa-3x fa-list',
      Login: 'fa fa-3x fa-sign-in',
      Delete: 'fa fa-3x fa-trash',
      RolesAdministracion: 'fa fa-3x fa-user-secret',
      Activar: '',
      BlanqueoSinPassword: '',
    };
    return mapping[codComando];
  }

  /**
   * Retorna el titulo traducido que representa al comando
   *
   * @param codComando El id del comando
   */
  getTituloComando(codComando: string): any {
    const titulo = {
      Alta: {
        titulo: this.sxTranslationService.getResource(
          'REGISTER_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'REGISTER_COMMAND_DESCRIPTION'
        ),
      },

      AltaExpress: {
        titulo: this.sxTranslationService.getResource(
          'REGISTER_EXPRESS_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'REGISTER_EXPRESS_COMMAND_DESCRIPTION'
        ),
      },
      Blanqueo: {
        titulo: this.sxTranslationService.getResource(
          'CLEAN_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'CLEAN_COMMAND_DESCRIPTION'
        ),
      },
      Bloqueo: {
        titulo: this.sxTranslationService.getResource(
          'BLOCK_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'BLOCK_COMMAND_DESCRIPTION'
        ),
      },
      CambioPassword: {
        titulo: this.sxTranslationService.getResource(
          'CHANGE_PASSWORD_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'CHANGE_PASSWORD_COMMAND_DESCRIPTION'
        ),
      },
      Consulta: {
        titulo: this.sxTranslationService.getResource(
          'QUERY_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'QUERY_COMMAND_DESCRIPTION'
        ),
      },
      Edicion: {
        titulo: this.sxTranslationService.getResource(
          'EDIT_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'EDIT_COMMAND_DESCRIPTION'
        ),
      },
      Listado: {
        titulo: this.sxTranslationService.getResource(
          'LIST_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'LIST_COMMAND_DESCRIPTION'
        ),
      },
      Login: {
        titulo: this.sxTranslationService.getResource(
          'LOGIN_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'LOGIN_COMMAND_DESCRIPTION'
        ),
      },
      Delete: {
        titulo: this.sxTranslationService.getResource(
          'DELETE_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'DELETE_COMMAND_DESCRIPTION'
        ),
      },
      RolesAdministracion: {
        titulo: this.sxTranslationService.getResource(
          'ROLE_ADMINISTRATION_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'ROLE_ADMINISTRATION_COMMAND_DESCRIPTION'
        ),
      },
      Activar: {
        titulo: this.sxTranslationService.getResource(
          'ACTIVE_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'ACTIVE_COMMAND_DESCRIPTION'
        ),
      },
      BlanqueoSinPassword: {
        titulo: this.sxTranslationService.getResource(
          'CLEAN_WITHOUT_PASSWORD_COMMAND'
        ),
        descripcion: this.sxTranslationService.getResource(
          'CLEAN_WITHOUT_PASSWORD_COMMAND_DESCRIPTION'
        ),
      },
    };
    return titulo[codComando];
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/socUserConfig.service.ts